/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import { UserOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { style } from '../../Styles';
import Driver from './Driver';
import PendingDriversComponent from './PendingDrivers';
import { permissionSuperAdmin } from '../../Utils/Constants/utils';
import { CheckDriverEnabled } from '../../Utils/CheckFeatures';

const DriverMultiTab = () => {
	const [activeTab, setActiveTab] = useState('1');
	const { auth } = useSelector((state) => state.auth);

	const onChange = (key) => {
		setActiveTab(key);
	};

	// Check if user is super admin
	const isSuperAdmin = auth?.profile?.role?.includes(permissionSuperAdmin);

	const driverTabItems = [
		{
			label: (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
					}}>
					<UserOutlined />
					<span style={style.navItem}>All Drivers</span>
				</div>
			),
			key: '1',
			children: <Driver isActive={activeTab === '1'} />,
			show: true,
		},
		...(CheckDriverEnabled() ? [{
			label: (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
					}}>
					<ClockCircleOutlined />
					<span style={style.navItem}>Pending</span>
				</div>
			),
			key: '2',
			children: <PendingDriversComponent isActive={activeTab === '2'} />,
			show: isSuperAdmin, // Only show for super admins
		}] : []),
	];

	// Filter tabs based on show property
	const visibleTabs = driverTabItems.filter((tab) => tab.show);

	useEffect(() => {
		// If current tab is not visible, switch to first visible tab
		if (!visibleTabs.find((tab) => tab.key === activeTab)) {
			setActiveTab(visibleTabs[0]?.key || '1');
		}
	}, [isSuperAdmin]);

	return (
		<Card hoverable bordered={false} style={style.cardStyle}>
			<Tabs activeKey={activeTab} onChange={onChange} type='card' items={visibleTabs} />
		</Card>
	);
};

export default DriverMultiTab;
